"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
const validate = (validation, value, fieldName, values) => {
    let error = null;
    if (Array.isArray(validation)) {
        for (const rule of validation) {
            error = rule(value, values, fieldName);
            if (error) {
                break;
            }
        }
    }
    else if (validation) {
        error = validation(value, values, fieldName);
    }
    return error || undefined;
};
exports.validate = validate;
//# sourceMappingURL=validate.js.map